import { Injectable } from '@angular/core';
import { Observable, of, take } from 'rxjs';
import { TokenService } from '../token/token.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { isJwtTokenValid } from './auth.utills';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _authenticated: boolean = false;

  constructor(
    private tokenService: TokenService,
    private router: Router,
  ) {}

  set authenticated(value: boolean) {
    this._authenticated = value;
  }

  get authenticated(): boolean {
    return this._authenticated;
  }

  public signOut(): void {
    const a = document.createElement('a');
    a.href = `${environment.scattre.auth}/sign-out?redirectUrl=${environment.origin}${this.router.url}`;
    a.target = '_self';
    a.rel = 'noopener noreferrer'; // 보안 강화
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  public signIn(): void {
    const a = document.createElement('a');
    a.href = `${environment.scattre.auth}/sign-in?redirectUrl=${environment.origin}${this.router.url}`;
    a.target = '_self';
    a.rel = 'noopener noreferrer'; // 보안 강화
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  public check(): Observable<boolean> {
    if (!this.tokenService.accessToken) return of(false);

    if (!isJwtTokenValid(this.tokenService.accessToken)) {
      if (!isJwtTokenValid(this.tokenService.refreshToken)) {
        this.tokenService.refreshToken = '';
        this.tokenService.accessToken = '';
        this.tokenService.idToken = '';
        return of(false);
      }
      this.tokenService
        .refresh()
        .pipe(take(1))
        .subscribe((token: string | undefined) => {
          if (!token) return of(false);
          this.tokenService.accessToken = token;
          return this.tokenService.tokenVerify();
        });
    }

    return this.tokenService.tokenVerify();
  }
}
